// extracted by mini-css-extract-plugin
export var alignCenter = "_8f-d";
export var bannerShown = "_8f-6";
export var buttonContent = "_8f-0";
export var cardList = "_8f-1";
export var centerContent = "_8f-2";
export var chevron = "_8f-3";
export var closePanelButton = "_8f-k";
export var conversationContextContainer = "_8f-l";
export var conversationDetailContainer = "_8f-4";
export var detailWrapper = "_8f-7";
export var dropdownButton = "_8f-e";
export var dropdownTitle = "_8f-9";
export var fullHeight = "_8f-5";
export var hidden = "_8f-a";
export var icon = "_8f-b";
export var mergeSuggestionWrapper = "_8f-m";
export var panel = "_8f-i";
export var portalButtonsWrapper = "_8f-c";
export var right = "_8f-j";
export var tableSummaryContainer = "_8f-8";
export var tableSummaryHeader = "_8f-g";
export var threeDotsButton = "_8f-f";
export var wide = "_8f-h";